import { IMPRESSION_ACTIONS, SCREEN_NAME, CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionWebviewRefreshMismatchAlertEvent = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_WEBVIEW_REFRESH_ORDER_MISMATCH_ALERT,
    });
};

export const clickWebviewRefreshMismatchPrimaryCTAEvent = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_WEBVIEW_REFRESH_ORDER_MISMATCH_ALERT,
    });
};
